(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/betslip/assets/javascripts/use-disable-overflow-x.js') >= 0) return;  svs.modules.push('/components/lb-ui/betslip/assets/javascripts/use-disable-overflow-x.js');
"use strict";


const {
  useEffect
} = React;
const useDisableOverflowX = () => {
  useEffect(() => {
    const mainContent = document.querySelector('.main-content');
    let oldVal;
    if (mainContent) {
      oldVal = mainContent.style.overflowX;
      mainContent.style.overflowX = 'visible';
    }
    return () => {
      if (mainContent) {
        mainContent.style.overflowX = oldVal;
      }
    };
  }, []);
};
setGlobal('svs.components.lbUi.betslip.useDisableOverflowX', useDisableOverflowX);

 })(window);